import { removeClasses } from '@/helpers/html/removeClasses';
import imageSourceHelpers from '@/helpers/images/imageSourceHelpers';
import IImage from '@/interfaces/IImage';

/**
 * Processes raw HTML string: updates protocol-relative and path-relative URLs,
 * then strips class attributes.
 * @param rawHtml - Raw HTML content.
 * @param rawImages - Images extracted from HTML to identify which to replace.
 * @param baseUrl - Base URL for path-relative fixes.
 * @returns Cleaned HTML string.
 */
export function processHtml(
    rawHtml: string,
    rawImages: IImage[],
    baseUrl: string
): string {
    // Step 1: Fix protocol-relative URLs (// to https)
    const protocolRelativeImages = imageSourceHelpers.getImagesStartingWithDoubleSlash(rawImages);
    let html = imageSourceHelpers.updateDescriptionHtmlWithHttps(rawHtml, protocolRelativeImages);

    // Step 2: Fix path-relative URLs (/ to baseUrl)
    const pathRelativeImages = imageSourceHelpers.getImagesStartingWithSingleSlash(rawImages);
    html = imageSourceHelpers.updateDescriptionHtmlWithBaseUrl(html, pathRelativeImages, baseUrl);

    // Step 3: Remove class attributes from HTML
    html = removeClasses(html);

    return html;
}


